import React from 'react';
import { Row, Col } from 'antd';
import { useForm, FormProvider } from 'react-hook-form';
import { ReactComponent as MapSearch } from 'assets/icons/map-search.svg';
import RHFInputField from 'shared/components/ReactHookFormFields/RHFInputField';
import RHFSelect from 'shared/components/ReactHookFormFields/RHFSelect';
import RHFCheckbox from 'shared/components/ReactHookFormFields/RHFCheckbox';
import RHFSwitch from 'shared/components/ReactHookFormFields/RHFSwitch';
import COButton from 'shared/components/COButton';
import FieldsRow from 'shared/components/FieldsRow';
import { FormType } from 'enums/FieldTypeEnums';
import { sampleFieldsRowData } from '../fieldsRowData';

interface FormValues {
  rhfInput: string;
  rhfSelect?: string;
  rhfCheckbox?: boolean;
  rhfSwitch?: boolean;
}

interface ItemProps {
  label: string;
  value: string;
}

const Selectoptions: ItemProps[] = [];
for (let i = 10; i < 36; i++) {
  const value = i.toString(36) + i;
  Selectoptions.push({
    label: `Long Label: ${value}`,
    value: value,
  });
}

const ReactHookFormComponent: React.FC = () => {
  const methods = useForm<FormValues>({
    mode: 'onBlur',
    defaultValues: {
      rhfInput: '',
      rhfSelect: undefined,
      rhfCheckbox: undefined,
      rhfSwitch: undefined,
    },
  });

  const { handleSubmit } = methods;

  const onSubmit = (data: FormValues) => console.log('Form Data:', data);

  return (
    <Row className="react-hook-form">
      <Col>
        <h1>React Hook Form</h1>
      </Col>
      <Col span={24}>
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Row align="middle" gutter={[20, 20]}>
              <Col span={6}>
                <RHFInputField
                  name="rhfInput"
                  placeholderstring="Enter Input"
                  label="RHF InputField"
                  suffix={<MapSearch />}
                />
              </Col>
              <Col span={6}>
                <RHFSelect
                  name="rhfSelect"
                  options={Selectoptions}
                  placeholderstring="Select Option"
                  label="RHF Select"
                />
              </Col>
              <Col span={4}>
                <RHFCheckbox
                  name="rhfCheckbox"
                  label={<Row>Checkbox Label</Row>}
                />
              </Col>
              <Col span={4}>
                <RHFSwitch
                  name="rhfSwitch"
                  label={<Row>Checkbox Switch</Row>}
                />
              </Col>
              <Col span={4}>
                <COButton primary submit>
                  Submit
                </COButton>
              </Col>
              <Col span={24}>
                <h1>Fields Row Implementation for ReactHookForms</h1>
              </Col>
              <Col span={24}>
                <FieldsRow
                  {...sampleFieldsRowData}
                  formType={FormType.REACT_HOOK_FORMS}
                />
              </Col>
            </Row>
          </form>
        </FormProvider>
      </Col>
    </Row>
  );
};

export default ReactHookFormComponent;
